/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.view', {
      url: '/:id/view?activeTab&templateId&subCaseState',
      params: {
        activeTab: { dynamic: true, inherit: false, value: '0' },
        templateId: { dynamic: true, inherit: false, value: null },
        subCaseState: { dynamic: true, inherit: false, value: null },
      },
      template: '<view case="$resolve.case"></view>',
      resolve: {
        /* @ngInject */
        case: ($http, $stateParams, $state) => $http
          .get(`/case/${$stateParams.id}/response`)
          .then(({ data: { data, reportCaseState } }) =>
            Object.assign(data, { id: $stateParams.id, reportCaseState }))
          .catch(() => $state.go('four-o-three')),
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/view/view.routes.js